import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  placeholder,
  ...props
}: SelectProps) {
  const selectId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-266">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-267">
          {label}
        </label>}
      <div className="relative" data-id="element-268">
        <select id={selectId} className={`
            flex h-11 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900
            focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent
            disabled:cursor-not-allowed disabled:opacity-50
            appearance-none
            transition-all duration-200
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
            ${className}
          `} {...props} data-id="element-269">
          {placeholder && <option value="" disabled selected data-id="element-270">
              {placeholder}
            </option>}
          {options.map(option => <option key={option.value} value={option.value} data-id="element-271">
              {option.label}
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500" data-id="element-272">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-273">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-274" />
          </svg>
        </div>
      </div>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-275">{error}</p>}
    </div>;
}